module.exports = __webpack_public_path__ + "static/media/igp_logo-title.e3fdcd59.png";